module.exports = __webpack_public_path__ + "img/norm-5.8eeebd8.png";